import { render, staticRenderFns } from "./InactiveTransmitterEvent.vue?vue&type=template&id=661cb42e&scoped=true"
import script from "./InactiveTransmitterEvent.vue?vue&type=script&lang=js"
export * from "./InactiveTransmitterEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661cb42e",
  null
  
)

export default component.exports